import { useState } from "react";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { recordsTicket } from "../../../services/userServices";
import {
  checkFileTypeImage,
  checkTicketTitle,
  checkTicketDescription,
} from "../../Validator/Validator";
import {
  ERROR_CODE6,
  ERROR_CODE7,
  ERROR_CODE8,
  ERROR_CODE9,
} from "../../Validator/ErrorCodes";
import { LoadingPage } from "../../LoadingPage/LoadingPage";
import {
  showLoadingPage,
  hiddenLoadingPage,
} from "../../../actions/loadingPage";
import { successMessage } from "../../../utils/messages";
//Styles and Icons
import styles from "./RecordTicket.module.scss";
import AttachIcon from "../../../styles/icon/attach_mail.svg";
import ArrowIcon from "../../../styles/icon/arrow_wallet.svg";
import OrderIcon from "../../../styles/icon/orderreport.svg";
import CartIcon from "../../../styles/icon/cartreport.svg";
import VerifyIcon from "../../../styles/icon/verifyreport.svg";
import OtherIcon from "../../../styles/icon/otherreport.svg";
import SuggestIcon from "../../../styles/icon/suggestreport.svg";
import ArrowBackIcon from "../../../styles/icon/arrow_back_fill.svg";

export default function RecordTicket() {
  const loadingBar = useSelector((state) => state.loadingBar.loading);
  const dispatch = useDispatch();
  const [showSubjectOption, setShowSubjectOption] = useState(false);
  //State's for handle inputs
  const [subjectTicket, setSubjectTicket] = useState("");
  const [ticketTitle, setTicketTitle] = useState("");
  const [descriptionTicket, setDescriptionTicket] = useState("");
  const [ticketFile, setTicketFile] = useState("");
  //State for handle ERROR's
  const [handleErrors, setHandleErrors] = useState({
    subject: "",
    title: "",
    description: "",
    file: "",
  });
  const history = useHistory();
  const recordNewTicket = async (e) => {
    e.preventDefault();
    if (!subjectTicket)
      return setHandleErrors({ ...handleErrors, subject: ERROR_CODE6 });
    let validTitle = checkTicketTitle(ticketTitle);
    if (!validTitle)
      return setHandleErrors({ ...handleErrors, title: ERROR_CODE7 });
    let validDescription = checkTicketDescription(descriptionTicket);
    if (!validDescription)
      return setHandleErrors({ ...handleErrors, description: ERROR_CODE8 });
    if (ticketFile) {
      let validFileType = checkFileTypeImage(ticketFile.name);
      if (!validFileType)
        return setHandleErrors({ ...handleErrors, file: ERROR_CODE9 });
    }

    dispatch(showLoadingPage());
    let currentSubject = "";
    switch (subjectTicket) {
      case "احراز هویت":
        currentSubject = "TECH";
        break;
      case "تراکنش":
        currentSubject = "TECH";
        break;
      case "سفارش گذاری":
        currentSubject = "SALES";
        break;
      case "سایر":
        currentSubject = "REGISTER";
        break;
      case "انتقادات":
        currentSubject = "REGISTER";
        break;
      default:
        currentSubject = "REGISTER";
        break;
    }
    let data = new FormData();
    data.append("department", currentSubject);
    data.append("title", ticketTitle);
    data.append("body", descriptionTicket);
    try {
      if (!ticketFile) {
        const { status } = await recordsTicket(data);
        if (status === 200) {
          successMessage("تیکت ارسال شد");
          history.push("/my-tickets");
        }
      } else {
        data.append("file", ticketFile);
        const { status } = await recordsTicket(data, true);
        if (status === 200) {
          successMessage("تیکت ارسال شد");
          history.push("/my-tickets");
        }
      }
    } catch (ex) {
      console.log(ex);
    } finally {
      dispatch(hiddenLoadingPage());
    }
  };
  return (
    <>
      {loadingBar && <LoadingPage />}
      <div
        className={`${styles.choice_container} ${
          showSubjectOption ? styles.choice_container_active : ""
        }`}
        onClick={() => setShowSubjectOption(false)}
      ></div>
      <div
        className={`${styles.choice_ticket_title} ${
          showSubjectOption ? styles.choice_ticket_title_active : ""
        }`}
      >
        <div className={styles.choice_row1}>
          <div
            className={styles.choice_item1}
            onClick={() => {
              setSubjectTicket("سفارش گذاری");
              setShowSubjectOption(false);
            }}
          >
            <div className={styles.icon_ticket_place}>
              <img src={OrderIcon} alt="" width={36} height={36} />
            </div>
            <div className={styles.title_ticket_place}>سفارش گذاری</div>
          </div>
          <div
            className={styles.choice_item1}
            onClick={() => {
              setSubjectTicket("تراکنش");
              setShowSubjectOption(false);
            }}
          >
            <div
              className={styles.icon_ticket_place}
              style={{ paddingRight: "5px" }}
            >
              <img src={CartIcon} alt="" width={40} height={40} />
            </div>
            <div className={styles.title_ticket_place}>تراکنش</div>
          </div>
          <div
            className={styles.choice_item1}
            onClick={() => {
              setSubjectTicket("احراز هویت");
              setShowSubjectOption(false);
            }}
          >
            <div className={styles.icon_ticket_place}>
              <img src={VerifyIcon} alt="" width={39} height={39} />
            </div>
            <div className={styles.title_ticket_place}>احراز هویت</div>
          </div>
        </div>
        <div className={styles.choice_row2}>
          <div
            className={styles.choice_item2}
            onClick={() => {
              setSubjectTicket("سایر");
              setShowSubjectOption(false);
            }}
          >
            <div className={styles.icon_ticket_place}>
              <img src={OtherIcon} alt="" width={40} height={40} />
            </div>
            <div className={styles.title_ticket_place}>سایر</div>
          </div>
          <div
            className={styles.choice_item2}
            onClick={() => {
              setSubjectTicket("انتقادات");
              setShowSubjectOption(false);
            }}
          >
            <div className={styles.icon_ticket_place}>
              <img src={SuggestIcon} alt="" width={40} height={40} />
            </div>
            <div className={styles.title_ticket_place}>انتقادات</div>
          </div>
        </div>
      </div>
      <div className={styles.container}>
        <div className={styles.back_btn}>
          <img
            src={ArrowBackIcon}
            alt="BACK"
            width={15}
            height={15}
            onClick={() => history.goBack()}
            className="convertPicToWhite"
          />
        </div>
        <div className={`font_color_white ${styles.record_ticket_title}`}>
          ثبت تیکت
        </div>
        <form onSubmit={(e) => recordNewTicket(e)}>
          <div className={styles.inputs_container}>
            <div className={styles.subject_container}>
              <input
                className={`changeBackgroundToWhite changeFontColorToBlack ${styles.subject_ticket}`}
                type="text"
                readOnly
                placeholder="موضوع تیکت را انتخاب کنید"
                onClick={() => {
                  setShowSubjectOption(true);
                  setHandleErrors({ ...handleErrors, subject: "" });
                }}
                value={subjectTicket}
              />
              <div className={styles.imgArrow}>
                <img
                  src={ArrowIcon}
                  alt=""
                  width={18}
                  height={18}
                  className="convertPicToGreen"
                />
              </div>
            </div>
            <div className={styles.title_container}>
              <input
                className={`changeBackgroundToWhite changeFontColorToBlack ${styles.title_ticket}`}
                type="text"
                placeholder="عنوان تیکت"
                onChange={(e) => {
                  setTicketTitle(e.target.value);
                  setHandleErrors({ ...handleErrors, title: "" });
                }}
                value={ticketTitle}
              />
            </div>
            <div className={styles.text_ticket_container}>
              <textarea
                className={`changeBackgroundToWhite changeFontColorToBlack ${styles.text_ticket_ticket}`}
                type="text"
                placeholder="متن تیکت"
                onChange={(e) => {
                  setDescriptionTicket(e.target.value);
                  setHandleErrors({ ...handleErrors, description: "" });
                }}
                value={descriptionTicket}
              />
            </div>
            <input
              id="file_upload"
              className={styles.file_input_ticket}
              type="file"
              onChange={(e) => setTicketFile(e.target.files[0])}
            />
            <label htmlFor="file_upload">
              <div className={styles.label_for_file}>
                <div className={styles.image_for_attach}>
                  <img src={AttachIcon} alt="" />
                </div>
                {ticketFile ? (
                  <div className={styles.file_name_uploaded}>
                    {ticketFile.name}
                  </div>
                ) : (
                  <div className={styles.label_file_placeholder}>
                    تصویر مورد نظر را ضمیمه کنید
                  </div>
                )}
              </div>
            </label>
            {ticketFile ? (
              <div
                className={styles.delete_file}
                onClick={() => setTicketFile("")}
              >
                پاک کردن فایل ضمیمه
              </div>
            ) : (
              ""
            )}
            <button type="submit">ارسال تیکت</button>
          </div>
        </form>
        <div className={styles.warning_for_inputs}>
          <ul>
            <li>{handleErrors.subject}</li>
            <li>{handleErrors.title}</li>
            <li>{handleErrors.description}</li>
            <li>{handleErrors.file}</li>
          </ul>
        </div>
      </div>
    </>
  );
}
